import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    this.element.dataset.traceSources =
      this.element.dataset.traceSources === "all" ? "used" : "all"
  }
}
